import { Component, OnInit } from "@angular/core";
import { Router, NavigationStart } from "@angular/router";
import { environment } from "@env";

import { OktaAuthService } from "@okta/okta-angular";
import * as OktaSignIn from "@okta/okta-signin-widget";

@Component({
  selector: "app-correspondence-login",
  templateUrl: "./correspondence-login.component.html",
  styleUrls: ["./correspondence-login.component.scss"]
})
export class CorrespondenceLoginComponent implements OnInit {
  signIn;
  widget = new OktaSignIn({
    baseUrl: environment.OKTA_ISSUER,
    authParams: {
      responseType: 'id_token',
      responseMode: 'okta_post_message',
      pkce: true,
      scopes: ['openid', 'profile', 'email']


    },
    logo:'assets/images/resmac_newlogo.png'

  });



  constructor(oktaAuth: OktaAuthService, public router: Router) {
    this.signIn = oktaAuth;
  }

  ngOnInit() {
    this.widget.renderEl(
        {
          el: "#okta-signin-container"
        },
        res => {
          if (res.status === "SUCCESS") {
            this.signIn.loginRedirect("correspondence/home", {
              sessionToken: res.session.token
            });
            // this.widget.hide();
          }
        },
        err => {
          throw err;
        }
    );
  }
}

